// this variables for the higher perfmance
(window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
(window as any).__zone_symbol__BLACK_LISTED_EVENTS = [
  'DOMContentLoaded',
  'beforeunload',
  // 'click',
  'contextmenu',
  'deviceready',
  'focus',
  'hashchange',
  // 'ionBackButton',
  'keydown',
  'keyup',
  // 'mousedown', store widget required
  // 'mousemove',
  // 'mouseup',
  'orientationchange',
  'pause',
  'pointercancel',
  'pointermove',
  'pointerup',
  // 'popstate',
  'resize',
  // 'resume',
  'scroll',
  // 'touchcancel',
  // 'touchend',
  // 'touchmove',
  // 'touchstart',
  'unload',
  'wheel',
];
